import { Box, Typography } from "@schaeffler-commerce/design-system";
import type { SignupStep } from "../../api/getOnboardingInitialData";
import CheckIcon from "@mui/icons-material/Check";

interface StepIconProps {
  active?: boolean;
  completed?: boolean;
  icon: React.ReactNode;
}

interface CustomStepIconProps extends StepIconProps {
  steps: SignupStep[];
}

export const CustomStepIcon = ({ active, completed, icon, steps }: CustomStepIconProps) => {
  const step = steps[Number(icon) - 1];

  return (
    <Box
      sx={{
        height: "24px",
        minWidth: active ? "auto" : 24,
        px: active ? 1 : 0,
        borderRadius: "100px",
        bgcolor: completed ? "success.container" : active ? "primary.main" : "surface.dim",
        color: completed ? "primary.main" : active ? "primary.contrastText" : "text.primary",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all .25s ease",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {completed ? (
        <CheckIcon
          fontSize="small"
          sx={{
            height: "20px",
            width: "20px",
          }}
        />
      ) : active ? (
        <Typography variant="labelLarge" sx={{
          color: "inherit"
        }}>
          {icon}. {step.label}
        </Typography>
      ) : (
        <Typography variant="labelLarge" sx={{
          color: "inherit"
        }}>
          {icon}
        </Typography>
      )}
    </Box>
  );
};
